
const 	$ = jQuery;

const 	$productNav = $('.js-sidebar-nav'),
		$topLevelItem = $productNav.find('.js-top-level-item'),
		$topLevelLink = $productNav.find('.js-top-level-link'),
		$subNavList = $productNav.find('.js-sub-nav-list'),
		$subNavLinkText = $productNav.find('.js-link-text'),
		$subNavLink = $productNav.find('.js-sub-nav-link'),
		$currentCategory = $productNav.find('.current-cat');

init();

function init() {
	$subNavList.each(function() {
		$(this).data('height', $(this).outerHeight());
	})

	closeSubNavs();

	if ( $currentCategory.length > 0 ) {
		let subNavHeight = $currentCategory.find('.js-sub-nav-list').data('height');

		$currentCategory.addClass('is-open').find('.js-sub-nav-list').css('height', subNavHeight);
	}
}

function closeSubNavs() {
	$subNavList.css('height', '0');
	$topLevelItem.removeClass('is-open');
}

$topLevelItem.on('click', (e) => {
	const 	$clickedElem = $(e.currentTarget),
			$subNav = $clickedElem.find($subNavList);

	if ( $clickedElem.hasClass('cat-parent') ) {

		if ( !$clickedElem.hasClass('is-open') ) {

			let subNavHeight = $clickedElem.find('.js-sub-nav-list').data('height');

			closeSubNavs();

			$clickedElem.addClass('is-open');
			$clickedElem.find('.js-sub-nav-list').css('height', subNavHeight);

		} else {

			$clickedElem.removeClass('is-open');
			$clickedElem.find('.js-sub-nav-list').css('height','0');

		}

		e.preventDefault();

	}


});

$subNavLink.on('click', (e) => {
	e.stopPropagation();
})

$subNavLinkText.on('click', (e) => {
	const 	$clickedElem = $(e.currentTarget),
			elemParentLink = $clickedElem.parents('a').attr('href'),
			$elemParentListItem = $clickedElem.closest('li');

	if ( $elemParentListItem.hasClass('is-open') ) {
		e.stopPropagation();
		if (elemParentLink) {
			window.location.href = elemParentLink;
		}
	}
})

